import { usePoFormattedTotalCosts } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FunctionComponent } from 'react';

interface PurchaseOrderTotalCostSummaryProps {}

const PurchaseOrderTotalCostSummary: FunctionComponent<PurchaseOrderTotalCostSummaryProps> = () => {
  const { totalProductPrice, totalProductAndDeviceFeePrice, totalDeviceFee, totalPcm } = usePoFormattedTotalCosts();

  return (
    <div>
      <p className="text-lg font-semibold">Products and Services: {totalProductPrice}</p>
      <p className="text-lg font-semibold">Device Fees: {totalDeviceFee}</p>
      <p className="text-xl font-bold">Total: {totalProductAndDeviceFeePrice}</p>
      <p className="text-lg font-semibold">PCM Cost: {totalPcm ? totalPcm : 'N/A'}</p>
    </div>
  );
};

export default PurchaseOrderTotalCostSummary;
